import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IChannelCountResponse,
  IChannelCountData,
  ICountryStatsData,
  IDashboardState,
  IFinanceChartData,
  IRegistrationData,
  IStatsData,
  ITopStatsData,
  IChannelTypeData,
} from './dashboard-types';

export const initialState: IDashboardState = {
  balance: null,
  phoneCalls: null,
  registeredUnregistered: null,
  topChannels: null,
  totalChannelsByCategory: null,
  totalGroupsByCategory: null,
  totalUsersOnPlatform: null,
  error: null,
  loader: false,
};

const dashboard = createSlice({
  name: '@@dashboard',
  initialState,
  reducers: {
    // One pattern for all
    getBalanceRequest: (state) => {
      state.loader = true;
    },
    getBalanceSuccess: (state, { payload }: PayloadAction<IFinanceChartData>) => {
      state.balance = payload;
      state.loader = false;
    },

    getPhoneCallsRequest: (state) => {
      state.loader = true;
    },
    getPhoneCallsSuccess: (state, { payload }: PayloadAction<IStatsData>) => {
      state.phoneCalls = payload;
      state.loader = false;
    },

    getRegisteredUnregisteredRequest: (state) => {
      state.loader = true;
    },
    getRegisteredUnregisteredSuccess: (state, { payload }: PayloadAction<IRegistrationData>) => {
      state.registeredUnregistered = payload;
      state.loader = false;
    },

    getTopChannelsRequest: (state) => {
      state.loader = true;
    },
    getTopChannelsSuccess: (state, { payload }: PayloadAction<ITopStatsData>) => {
      state.topChannels = payload;
      state.loader = false;
    },

    getTotalChannelsByCategoryRequest: (state) => {
      state.loader = true;
    },
    getTotalChannelsByCategorySuccess: (state, { payload }: PayloadAction<IChannelCountData>) => {
      state.totalChannelsByCategory = payload;
      state.loader = false;
    },

    getTotalGroupsByCategoryRequest: (state) => {
      state.loader = true;
    },
    getTotalGroupsByCategorySuccess: (state, { payload }: PayloadAction<IChannelTypeData>) => {
      state.totalGroupsByCategory = payload;
      state.loader = false;
    },

    getTotalUsersOnPlatformRequest: (state) => {
      state.loader = true;
    },
    getTotalUsersOnPlatformSuccess: (state, { payload }: PayloadAction<ICountryStatsData>) => {
      state.totalUsersOnPlatform = payload;
      state.loader = false;
    },

    dashboardInitState: (state) => {
      state.loader = false;
      state.error = null;
    },
  },
});

export default dashboard.reducer;

export const {
  getBalanceRequest,
  getBalanceSuccess,
  getPhoneCallsRequest,
  getPhoneCallsSuccess,
  getRegisteredUnregisteredRequest,
  getRegisteredUnregisteredSuccess,
  getTopChannelsRequest,
  getTopChannelsSuccess,
  getTotalChannelsByCategoryRequest,
  getTotalChannelsByCategorySuccess,
  getTotalGroupsByCategoryRequest,
  getTotalGroupsByCategorySuccess,
  getTotalUsersOnPlatformRequest,
  getTotalUsersOnPlatformSuccess,
  dashboardInitState,
} = dashboard.actions;
